import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectActivityStoreActions,
  ProjectActivityStoreSelectors,
  ProjectActivityStoreReducer,
} from './index';
import { ProjectActivityDto } from '@cradua/data';

@Injectable()
export class ProjectActivityFacade {
  constructor(
    private store: Store<
      ProjectActivityStoreReducer.ProjectActivityPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectActivityStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectActivityStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectActivityStoreSelectors.getProjectActivityError
  );

  getselected() {
    return this.store.select(ProjectActivityStoreSelectors.getSelected);
  }

  get isLoadingProjectActivity() {
    this.store.dispatch(ProjectActivityStoreActions.loadProjectActivity());
    return this.store.select(
      ProjectActivityStoreSelectors.loadingProjectActivity
    );
  }

  get loadProjectActivity() {
    this.store.dispatch(ProjectActivityStoreActions.loadProjectActivity());
    return this.store.select(
      ProjectActivityStoreSelectors.getAllProjectActivity
    );
  }

  searchProjectActivityRecord(query) {
    this.store.dispatch(
      ProjectActivityStoreActions.searchProjectActivityRecord({ query })
    );
  }

  addProjectActivity(newProjectActivity: ProjectActivityDto[]) {
    this.store.dispatch(
      ProjectActivityStoreActions.addProjectActivity({
        newProjectActivity,
      })
    );
  }

  updateProjectActivity(updateProjectActivity: ProjectActivityDto[]) {
    this.store.dispatch(
      ProjectActivityStoreActions.updateProjectActivity({
        updateProjectActivity,
      })
    );
  }

  removeProjectActivity(ids: string[]) {
    this.store.dispatch(
      ProjectActivityStoreActions.removeProjectActivity({ ids })
    );
  }
}
